import { type ReactElement } from 'react'

import { type Pathname } from '@Types/navigation/navigation'

export type ModalNavControls = {
  goToModalPage: (pageName: Pathname) => void
  goToDynamicModalPage: (dynamicPage: ReactElement) => void
  goToParentPage: VoidFunction
}

export type ModalControls = ModalNavControls & {
  closeModal: VoidFunction
}

export const DRAWER_TRANSITION_DURATION = 300
